import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ToTopButtonComponent } from './to-top-button.component';
import { IconsModule } from 'core/components/icons/icons.module';



@NgModule({
  declarations: [
    ToTopButtonComponent
  ],
  exports: [
    ToTopButtonComponent
  ],
  imports: [
    CommonModule,
    IconsModule,
    NgOptimizedImage
  ]
})
export class ToTopButtonModule { }
